import {
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { compose } from "@reduxjs/toolkit";
import React from "react";
import { connect } from "react-redux";
import swal from "sweetalert";
import { ButtonCompo } from "../../components/Comman/Button";
import { TextFieldCompo } from "../../components/Comman/TextFieldCompo";
import DynamicDetails from "../../components/dynamicscreens/DynamicDetails";
import DynamicFormWithoutSave from "../../components/dynamicscreens/DynamicFormWithoutSave";
import { withRouter } from "../../components/withRouter";
import endpoint from "../../config/endpoints";
import {
  challanSettledMsg,
  challanSettleWarningMsg,
  noInternetMsg,
  saveFailedMsg,
  serverMsg,
} from "../../config/messageconstant";
import { DayEndProcessForDriverJson } from "../../DynamicFormsJson/MastersJSON/dayEndProcessForDriver";
import {
  getAreaByTalukaPostBody,
  getAreaByUserType,
} from "../../Slice/area.slice";
import {
  getBeatBySalesTeamIdAndAreaIdPost,
  getBeatBySalesTeamIdAndLoginPersonAreas,
} from "../../Slice/beat.slice";
import { setCategoryAndItemForChallan } from "../../Slice/category.slice";
import { getDistrictByZone } from "../../Slice/district.slice";
import { getRegionNew } from "../../Slice/region.slice";
import {
  getDriversByStockHolderId,
  getSalesExecutiveByAreaId,
} from "../../Slice/salesExecutive.slice";
import { getStockholderByAreaIdsForFilter } from "../../Slice/StackHolder.slice";
import { getStateByRegion } from "../../Slice/state.slice";
import { getTalukaByDistrict } from "../../Slice/taluka.slice";
import { getZoneByState } from "../../Slice/zone.slice";
import { apiGet, apiPost } from "../../utils/api_service";
import { showLoador, showNotification } from "../Landing/Landing.slice";
import "./DayEndCSS.css";
import LandingScreenHeader from "../../components/Comman/LandingScreenHeader";
class DayEndProcessForDriver extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      DataToSet: [],
      beatAssignList: [],
      salesTeamId: "",
      adminFlag: false,
      stockHolderId: "",
      searchValue: "",
      value: 0,
      total: 0,
      totalOfQty: 0,
      orderList: [],
      vehicleId: "",
      driverId: "",
      fieldData: {},
      date: "",
      transferNo: "",
      selectedAreaIds: [],
      dataList: [],
      formError: {},
      beatNames: [],
      dynamicMasterData: {
        areaDetail: this.props.areaList.area,
        regionDetail: this.props.regionList?.region,
        stateDetail: this.props.stateList?.stateByRegion,
        zoneDetail: this.props.zoneList?.zoneByState,
        districtDetail: this.props.districtList?.districtByZone,
        talukaDetail: this.props.talukaList?.talukaByDistrict,
        areaDetail: this.props.areaList?.areaByTaluka,
        stockHolderDetail: this.props.stockHolderList?.stockholderByArea,
        driverDetail: this.props.driverList?.driverByStockHolder,
      },
    };
  }
  async componentDidMount() {
    const {
      setCategoryAndItemForChallan,
      getRegionNew,
      getAreaByUserType,
      showLoador,
      showNotification,
    } = this.props;
    const { adminFlag } = this.state;

    if (navigator.onLine) {
      setCategoryAndItemForChallan({ row: [] });

      const userTypeId = localStorage.getItem("userTypeId");

      if (userTypeId == 1 || userTypeId == 6) {
        showLoador({ loador: true });
        getRegionNew().then(({ success }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          }
        });

        this.setState({
          adminFlag: true,
        });
      } else {
        showLoador({ loador: true });
        getAreaByUserType().then(({ success }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          }
        });
      }
    } else {
      this.props.showNotification({ msg: noInternetMsg, severity: "error" });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.regionList !== nextProps.regionList) {
      if (this.props.regionList?.region !== nextProps.regionList?.region) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            regionDetail: nextProps.regionList?.region,
          },
        });
      }
    }
    if (this.props.stateList !== nextProps.stateList) {
      if (
        this.props.stateList?.stateByRegion !==
        nextProps.stateList?.stateByRegion
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            stateDetail: nextProps.stateList?.stateByRegion,
          },
        });
      }
    }
    if (this.props.zoneList !== nextProps.zoneList) {
      if (
        this.props.zoneList?.zoneByState !== nextProps.zoneList?.zoneByState
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            zoneDetail: nextProps.zoneList?.zoneByState,
          },
        });
      }
    }
    if (this.props.districtList !== nextProps.districtList) {
      if (
        this.props.districtList?.districtByZone !==
        nextProps.districtList?.districtByZone
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            districtDetail: nextProps.districtList?.districtByZone,
          },
        });
      }
    }
    if (this.props.talukaList !== nextProps.talukaList) {
      if (
        this.props.talukaList?.talukaByDistrict !==
        nextProps.talukaList?.talukaByDistrict
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            talukaDetail: nextProps.talukaList?.talukaByDistrict,
          },
        });
      }
    }
    if (this.props.areaList !== nextProps.areaList) {
      if (this.props.areaList?.area !== nextProps.areaList?.area) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            areaDetail: nextProps.areaList?.area,
          },
        });
      }
    }

    if (this.props.areaList !== nextProps.areaList) {
      if (
        this.props.areaList?.areaByTaluka !== nextProps.areaList?.areaByTaluka
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            areaDetail: nextProps.areaList?.areaByTaluka,
          },
        });
      }
    }
    if (this.props.stockHolderList !== nextProps.stockHolderList) {
      if (
        this.props.stockHolderList?.stockholderByArea !==
        nextProps.stockHolderList?.stockholderByArea
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            stockHolderDetail: nextProps.stockHolderList?.stockholderByArea,
          },
        });
      }
    }
    if (this.props.driverList !== nextProps.driverList) {
      if (
        this.props.driverList?.driverByStockHolder !==
        nextProps.driverList?.driverByStockHolder
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            driverDetail: nextProps.driverList?.driverByStockHolder,
          },
        });
      }
    }
  }

  getListById = async (data) => {
    const {
      getStateByRegion,
      getZoneByState,
      getDistrictByZone,
      getTalukaByDistrict,
      getAreaByTalukaPostBody,
      getStockholderByAreaIdsForFilter,
      getDriversByStockHolderId,
      showLoador,
      showNotification,
    } = this.props;
    const { selectedAreaIds, stockHolderId, adminFlag } = this.state;
    if (navigator.onLine) {
      if (adminFlag) {
        if (data.stockHolder) {
          this.setState({ stockHolderId: data.stockHolder });
        }
      }

      if (data.region && data.region != "") {
        showLoador({ loador: true });
        await getStateByRegion({ regionIds: data.region }).then(
          ({ success }) => {
            showLoador({ loador: false });
            if (!success) {
              showNotification({ msg: serverMsg, severity: "error" });
            }
          }
        );
      }
      if (data.state && data.state != "") {
        showLoador({ loador: true });
        await getZoneByState({ stateIds: data.state }).then(({ success }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          }
        });
      }
      if (data.zone && data.zone != "") {
        showLoador({ loador: true });
        await getDistrictByZone({ zoneIds: data.zone }).then(({ success }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          }
        });
      }
      if (data.district && data.district != "") {
        showLoador({ loador: true });
        await getTalukaByDistrict({ districtIds: data.district }).then(
          ({ success }) => {
            showLoador({ loador: false });
            if (!success) {
              showNotification({ msg: serverMsg, severity: "error" });
            }
          }
        );
      }
      if (data.taluka && data.taluka != "") {
        let talukaJson = {
          talukaIds: data.taluka,
        };
        showLoador({ loador: true });
        await getAreaByTalukaPostBody({ talukaIds: talukaJson }).then(
          ({ success }) => {
            showLoador({ loador: false });
            if (!success) {
              showNotification({ msg: serverMsg, severity: "error" });
            }
          }
        );
      }

      if (adminFlag) {
        if (data.area && data.area != "") {
          this.setState({ selectedAreaIds: data.area });

          showLoador({ loador: true });
          await getStockholderByAreaIdsForFilter({ areaIds: data.area }).then(
            ({ success }) => {
              showLoador({ loador: false });
              if (!success) {
                showNotification({ msg: serverMsg, severity: "error" });
              }
            }
          );
        }
        if (data.stockHolder && data.stockHolder != "") {
          let areaIdsObj = {
            areaIds: selectedAreaIds,
          };

          showLoador({ loador: true });
          await getDriversByStockHolderId({
            stockHolderId: data.stockHolder,
            areaIdJson: areaIdsObj,
          }).then(({ success }) => {
            showLoador({ loador: false });
            if (!success) {
              showNotification({ msg: serverMsg, severity: "error" });
            }
          });
        }
      } else {
        if (data.area && data.area != "") {
          let stockHolderId = localStorage.getItem("userId");

          this.setState({ stockHolderId: stockHolderId });

          let areaIdsObj = {
            areaIds: data.area,
          };

          showLoador({ loador: true });
          await getDriversByStockHolderId({
            stockHolderId: "",
            areaIdJson: areaIdsObj,
          }).then(({ success }) => {
            showLoador({ loador: false });
            if (!success) {
              showNotification({ msg: serverMsg, severity: "error" });
            }
          });
        }
      }

      if (data.driver && data.driver !== null) {
        this.setState({ driverId: data.driver });

        showLoador({ loador: true });
        await apiGet({
          url:
            endpoint.vanStockTransferHeader +
            "/day-end-details-by-driver?driverId=" +
            data.driver +
            "&stockStakeHolderId=" +
            stockHolderId,
        }).then(({ data, success }) => {
          showLoador({ loador: false });
          if (success) {
            if (data !== null && data.data !== null) {
              let rowData = data.data;
              this.setState({
                beatNames: rowData.beatNames || "",
                DataToSet: [],
              });
              const dataList = data.data.vanStockTransferDetail.map(
                (dataObj, index) => {
                  return {
                    index: index + 1,
                    id: dataObj.id !== null ? dataObj.id : "",
                    date: dataObj.date !== null ? dataObj.date : "",
                    productId:
                      dataObj.productId !== null ? dataObj.productId : "",
                    productName:
                      dataObj.productName !== null ? dataObj.productName : "",
                    primaryQty:
                      dataObj.primaryQty !== null ? dataObj.primaryQty : "",
                    secondaryQty:
                      dataObj.secondaryQty !== null ? dataObj.secondaryQty : "",
                    primaryInQty:
                      dataObj.primaryInQty !== null ? dataObj.primaryInQty : "",
                    secondaryInQty:
                      dataObj.secondaryInQty !== null
                        ? dataObj.secondaryInQty
                        : "",
                    primaryOutQty:
                      dataObj.primaryOutQty !== null
                        ? dataObj.primaryOutQty
                        : "",
                    secondaryOutQty:
                      dataObj.secondaryOutQty !== null
                        ? dataObj.secondaryOutQty
                        : "",
                    primaryBillQty:
                      dataObj.primaryBillQty !== null
                        ? dataObj.primaryBillQty
                        : "",
                    secondaryBillQty:
                      dataObj.secondaryBillQty !== null
                        ? dataObj.secondaryBillQty
                        : "",
                    primarySettleQty:
                      dataObj.primarySettleQty !== null
                        ? dataObj.primarySettleQty
                        : "",
                    secondarySettleQty:
                      dataObj.secondarySettleQty !== null
                        ? dataObj.secondarySettleQty
                        : "",
                    primaryDiffQty:
                      dataObj.primaryDiffQty !== null
                        ? dataObj.primaryDiffQty
                        : "",
                    secondaryDiffQty:
                      dataObj.secondaryDiffQty !== null
                        ? dataObj.secondaryDiffQty
                        : "",
                    grandTotalSecQty:
                      dataObj.grandTotalSecQty !== null
                        ? dataObj.grandTotalSecQty
                        : "",
                    conversionValue:
                      dataObj.conversionValue !== null
                        ? dataObj.conversionValue
                        : "",
                    ...dataObj,
                  };
                }
              );

              this.setState({
                fieldData: rowData,
                dataList,
                transferNo:
                  rowData.transferNo !== null ? rowData.transferNo : "",
                stockHolderId:
                  rowData.stockStakeHolderId !== null
                    ? rowData.stockStakeHolderId
                    : "",
                date: rowData.date !== null ? rowData.date : "",
                vehicleId: rowData.vehicleId !== null ? rowData.vehicleId : "",
                driverId: rowData.driverId !== null ? rowData.driverId : "",

                DataToSet: [
                  {
                    xs: 12,
                    sm: 4,
                    md: 4,
                    lg: 4,
                    label: "Transfer No",
                    value:
                      rowData.transferNo !== null ? rowData.transferNo : "",
                  },
                  {
                    xs: 12,
                    sm: 4,
                    md: 4,
                    lg: 4,
                    label: "Date",
                    value: rowData.date !== null ? rowData.date : "",
                  },
                  {
                    xs: 12,
                    sm: 4,
                    md: 4,
                    lg: 4,
                    label: "Stock Holder",
                    value:
                      rowData.stockStakeHolderFirmName !== null &&
                        rowData.stockStakeHolderTypePrefix !== null
                        ? rowData.stockStakeHolderFirmName +
                        " (" +
                        rowData.stockStakeHolderTypePrefix +
                        ")"
                        : "",
                  },
                  {
                    xs: 12,
                    sm: 4,
                    md: 4,
                    lg: 4,
                    label: "Driver Name",
                    value:
                      rowData.driverName !== null ? rowData.driverName : "",
                  },
                  {
                    xs: 12,
                    sm: 4,
                    md: 4,
                    lg: 4,
                    label: "Vehicle No",
                    value: rowData.vehicleNo !== null ? rowData.vehicleNo : "",
                  },
                  {
                    xs: 12,
                    sm: 4,
                    md: 4,
                    lg: 4,
                    label: "Bill Count",
                    value: rowData.billCount !== null ? rowData.billCount : "-",
                  },
                  {
                    xs: 12,
                    sm: 4,
                    md: 4,
                    lg: 4,
                    label: "Bill Amt",
                    value: rowData.billAmt !== null ? rowData.billAmt : "-",
                  },
                  {
                    xs: 12,
                    sm: 4,
                    md: 4,
                    lg: 4,
                    label: "Bill Qty",
                    value: rowData.billQty !== null ? rowData.billQty : "-",
                  },

                  // {
                  //   xs: 12,
                  //   sm: 8,
                  //   md: 8,
                  //   lg: 8,
                  //   label: "Beat Names",
                  //   value: rowData.beatNames !== null ? rowData.beatNames : "",
                  // },
                ],
              });
            } else {
              showNotification({
                msg: "No Active Challan Found",
                severity: "error",
              });
              this.setState({ dataList: [] });
            }
          } else {
            showNotification({ msg: serverMsg, severity: "error" });
          }
        });
      }
    } else {
      this.props.showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };

  onChangeTextField = (id) => (event) => {
    const { dataList } = this.state;
    const { name, value } = event.target;

    if (/^-?\d*$/.test(value)) {
      const updatedList = dataList.map((dataObj) => {
        if (dataObj.id === id) {
          return {
            ...dataObj,
            [name]: value,
          };
        }
        return dataObj;
      });
      this.setState({ dataList: updatedList });
    }
  };

  checkValidationOnSubmit = () => {
    const { dataList } = this.state;
    let formError = {};
    let formIsValid = true;

    dataList.map((item, index) => {
      if (item.secondaryDiffQty === "" || item.secondaryDiffQty === null) {
        formIsValid = false;
        formError[`secondaryDiffQtyError${item.id}`] = "Difference is required";
      }
    });

    this.setState({ formError });
    return formIsValid;
  };

  submitHandler = () => {
    if (this.checkValidationOnSubmit()) {
      const { dataList, fieldData } = this.state;

      let dataJson = {
        ...fieldData,
        vanStockTransferDetail: dataList,
      };

      this.onSubmit(dataJson);
    }
  };

  onSubmit = (dataJson) => {
    const { showLoador, showNotification } = this.props;

    console.log("dataJson-", dataJson);

    if (navigator.onLine) {
      swal({
        title: "Are you sure?",
        text: challanSettleWarningMsg,
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
          showLoador({ loador: true });
          apiPost({
            url: endpoint.vanStockTransferHeader + "/day-end-details-save",
            postBody: dataJson,
          }).then(({ success }) => {
            showLoador({ loador: false });
            if (success) {
              showNotification({
                msg: challanSettledMsg,
              });
              window.location.reload();
            } else {
              showNotification({
                msg: saveFailedMsg,
                severity: "error",
              });
            }
          });
        }
      });
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };

  onSearchBox = (searchValue) => {
    this.setState({
      searchValue: searchValue,
    });
  };

  getFilteredTableData = (searchData) => {
    const { searchValue } = this.state;
    return searchData.filter((currentRow) => {
      let isValid = false;
      if (
        (currentRow["productName"] &&
          currentRow["productName"]
            .toString()
            .toLowerCase()
            .includes(searchValue.trim().toLowerCase())) ||
        (currentRow["secondaryQty"] &&
          currentRow["secondaryQty"]
            .toString()
            .toLowerCase()
            .includes(searchValue.trim().toLowerCase())) ||
        (currentRow["secondaryInQty"] &&
          currentRow["secondaryInQty"]
            .toString()
            .toLowerCase()
            .includes(searchValue.trim().toLowerCase())) ||
        (currentRow["secondaryOutQty"] &&
          currentRow["secondaryOutQty"]
            .toString()
            .toLowerCase()
            .includes(searchValue.trim().toLowerCase())) ||
        (currentRow["secondaryBillQty"] &&
          currentRow["secondaryBillQty"]
            .toString()
            .toLowerCase()
            .includes(searchValue.trim().toLowerCase())) ||
        (currentRow["grandTotalSecQty"] &&
          currentRow["grandTotalSecQty"]
            .toString()
            .toLowerCase()
            .includes(searchValue.trim().toLowerCase()))
      ) {
        isValid = true;
        return true;
      }
    });
  };

  render() {
    const {
      matrixData,
      dynamicMasterData,
      DataToSet,
      dayList,
      adminFlag,
      value,
      totalOfQty,
      total,
      dataList,
      formError,
    } = this.state;
    const { category } = this.props;

    return (
      <>
        <Paper
          sx={{
            p: 2,
            borderRadius: 2,
          }}
          elevation={0}
        >
          <DynamicFormWithoutSave
            showBackToList={true}
            dynamicMasterData={dynamicMasterData}
            showSaveBtn={DayEndProcessForDriverJson.showSaveBtn}
            showTitle={DayEndProcessForDriverJson.showTitle}
            screenTitle={DayEndProcessForDriverJson.screenTitle}
            fieldMeta={
              adminFlag
                ? DayEndProcessForDriverJson.fieldMeta
                : DayEndProcessForDriverJson.fieldMetaForStockHolder
            }
            showCancel={DayEndProcessForDriverJson.showCancel}
            apiBaseURL={DayEndProcessForDriverJson.apiBaseURL}
            showSaveNextBtn={false}
            saveBtnText={""}
            showSaveBtnMain={false}
            getListById={this.getListById}
          />

          <br />

          {dataList.length !== 0 && (
            <>
              <div className="challan-container">
                <div
                  className="challan-header"
                  style={{ justifyContent: "center", alignItems: "center" }}
                >
                  <div className="challan-title">
                    <span role="img" aria-label="truck">
                      {" "}
                      🚚{" "}
                    </span>
                    <b>CHALLAN</b>
                  </div>
                </div>
                <div className="challan-row">
                  <div className="challan-details"></div>
                </div>

                <DynamicDetails DataToSet={DataToSet} />

                {this.state.beatNames && (
                  <div
                    style={{
                      display: "flex",
                      width: "100%",
                      marginBottom: "6px",
                      alignItems: "center",
                    }}
                  >
                    <div
                      style={{
                        width: "22%",
                        fontWeight: 200,
                        color: "#00bdd8",
                        marginTop: "-18px",
                        marginLeft: "15px",
                      }}
                    >
                      Beat Names :
                    </div>

                    <div
                      style={{
                        width: "170%",
                        whiteSpace: "-12px",
                        color: "#000",
                        marginTop: "-12px",
                        marginRight: "10px",
                      }}
                    >
                      {this.state.beatNames || "-"}
                    </div>
                  </div>
                )}

                <LandingScreenHeader
                  screenTitle={""}
                  showSearchBox={true}
                  showTable={true}
                  showFilter={false}
                  showPdfDownload={false}
                  showExcelDownload={false}
                  onSearch={this.onSearchBox}
                />

                <TableContainer sx={{ maxHeight: 440 }}>
                  <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                      <TableRow>
                        <TableCell align="center" style={{ minWidth: "70px" }}>
                          Sr. No.
                        </TableCell>
                        <TableCell align="center" style={{ minWidth: "250px" }}>
                          Product Name
                        </TableCell>
                        <TableCell align="center" style={{ minWidth: "170px" }}>
                          Challan Qty
                        </TableCell>
                        <TableCell align="center" style={{ minWidth: "170px" }}>
                          In Qty
                        </TableCell>
                        <TableCell align="center" style={{ minWidth: "170px" }}>
                          Out Qty
                        </TableCell>
                        <TableCell align="center" style={{ minWidth: "170px" }}>
                          Bill Qty
                        </TableCell>
                        <TableCell align="center" style={{ minWidth: "150px" }}>
                          Total
                        </TableCell>
                        <TableCell align="center" style={{ maxWidth: "100px" }}>
                          Difference
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {this.getFilteredTableData(dataList).map(
                        (productObject, indexRow) => {
                          return (
                            <TableRow>
                              <TableCell
                                align="center"
                                component="td"
                                scope="row"
                              >
                                {indexRow + 1}
                              </TableCell>
                              <TableCell
                                align="left"
                                component="td"
                                scope="row"
                              >
                                {productObject.productName}
                              </TableCell>
                              <TableCell
                                align="right"
                                component="td"
                                scope="row"
                              >
                                {productObject.secondaryQty}
                              </TableCell>
                              <TableCell
                                align="right"
                                component="td"
                                scope="row"
                              >
                                {productObject.secondaryInQty}
                              </TableCell>
                              <TableCell
                                align="right"
                                component="td"
                                scope="row"
                              >
                                {productObject.secondaryOutQty}
                              </TableCell>
                              <TableCell
                                align="right"
                                component="td"
                                scope="row"
                              >
                                {productObject.secondaryBillQty}
                              </TableCell>
                              <TableCell
                                align="right"
                                component="td"
                                scope="row"
                              >
                                {productObject.grandTotalSecQty}
                              </TableCell>
                              {adminFlag ? (
                                <TableCell
                                  align="right"
                                  component="td"
                                  scope="row"
                                >
                                  {productObject.secondaryDiffQty}
                                </TableCell>
                              ) : (
                                <TableCell
                                  align="right"
                                  component="td"
                                  scope="row"
                                >
                                  <TextFieldCompo
                                    placeHolder="Difference"
                                    size="small"
                                    color="primary"
                                    name="secondaryDiffQty"
                                    type="text"
                                    value={productObject.secondaryDiffQty}
                                    onChange={this.onChangeTextField(
                                      productObject.id
                                    )}
                                    fullWidth={false}
                                    isError={
                                      formError[
                                        `secondaryDiffQtyError${productObject.id}`
                                      ]
                                        ? formError[
                                        `secondaryDiffQtyError${productObject.id}`
                                        ]
                                        : ""
                                    }
                                    errorText={
                                      formError[
                                        `secondaryDiffQtyError${productObject.id}`
                                      ]
                                        ? formError[
                                        `secondaryDiffQtyError${productObject.id}`
                                        ]
                                        : ""
                                    }
                                  />
                                </TableCell>
                              )}
                            </TableRow>
                          );
                        }
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </div>

              {!this.state.adminFlag && (
                <Grid container spacing={1}>
                  <Grid
                    container
                    xs={12}
                    sm={12}
                    md={12}
                    sx={{ justifyContent: "flex-end" }}
                  >
                    <ButtonCompo
                      size="medium"
                      type="submit"
                      variant="contained"
                      name={"Settle"}
                      onClick={this.submitHandler}
                    />
                  </Grid>
                </Grid>
              )}
            </>
          )}
        </Paper>
      </>
    );
  }
}
const mapStateToProps = (state) => ({
  areaList: state.area,
  regionList: state.region,
  stateList: state.states,
  zoneList: state.zone,
  districtList: state.district,
  talukaList: state.taluka,
  stockHolderList: state.stackholder,
  driverList: state.salesExecutive,
  category: state.category,
});
const mapDispatchToProps = {
  showLoador,
  showNotification,
  getRegionNew,
  getZoneByState,
  getDistrictByZone,
  getTalukaByDistrict,
  getStateByRegion,
  getAreaByUserType,
  getSalesExecutiveByAreaId,
  getBeatBySalesTeamIdAndLoginPersonAreas,
  getBeatBySalesTeamIdAndAreaIdPost,
  getAreaByTalukaPostBody,
  getStockholderByAreaIdsForFilter,
  getDriversByStockHolderId,
  setCategoryAndItemForChallan,
};
export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(DayEndProcessForDriver);
